module.exports = __webpack_public_path__ + "static/media/man-weight.e20e1ca3.svg";